import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { FunnelType, Step } from "@/types/enums";
import type { UnitGroup } from "@/types";
import { RootState } from "@/store.ts";

export interface JourneyState {
    isOpen: boolean;
    step: Step | null;
    funnelType: FunnelType | undefined;
    selectedUnitId: number | string;
    selectedUnitGroup: UnitGroup | null;
    selectedPromo: number;
    stepList: string[];
}

const initialState: JourneyState = {
    isOpen: false,
    step: null,
    funnelType: undefined,
    selectedUnitId: 0,
    selectedUnitGroup: null,
    selectedPromo: 0,
    stepList: [],
};

const journeySlice = createSlice({
    name: "journey",
    initialState,
    reducers: {
        openJourney: (state) => {
            state.isOpen = true;
        },
        closeJourney: (state) => {
            state.isOpen = false;
        },
        setIsOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setUnitJourneyStep: (state, action: PayloadAction<Step>) => {
            state.step = action.payload;
        },
        setFunnelType: (
            state,
            action: PayloadAction<FunnelType | undefined>,
        ) => {
            state.funnelType = action.payload;
        },
        setSelectedUnitId: (state, action: PayloadAction<number | string>) => {
            state.selectedUnitId = action.payload;
        },
        setSelectedUnitGroup: (
            state,
            action: PayloadAction<UnitGroup | null>,
        ) => {
            state.selectedUnitGroup = action.payload;
        },
        setSelectedPromo: (state, action: PayloadAction<number>) => {
            state.selectedPromo = action.payload;
        },
        setStepList: (state, action: PayloadAction<string[]>) => {
            state.stepList = action.payload;
        },
        resetJourney: (state) => {
            state.isOpen = false;
            state.step = null;
            state.funnelType = undefined;
            state.selectedUnitId = 0;
            state.selectedUnitGroup = null;
            state.selectedPromo = 0;
            state.stepList = [];
        },
        goBackStep: (state) => {
            const currentStepIndex = state.stepList.findIndex(
                (element) => element === state.step,
            );
            console.log("current step index: ", currentStepIndex);
            const previousStep = state.stepList[currentStepIndex - 1] as Step;
            console.log("previous step: ", previousStep);
            if (previousStep) {
                state.step = previousStep;
            }
        },
        initializeJourney: (
            state,
            action: PayloadAction<{
                unitId: number | string;
                unitGroup: UnitGroup;
                selectedPromo: number;
                stepList: string[];
                step: Step;
                funnelType?: FunnelType;
            }>,
        ) => {
            state.selectedUnitId = action.payload.unitId;
            state.selectedUnitGroup = action.payload.unitGroup;
            state.selectedPromo = action.payload.selectedPromo;
            state.stepList = action.payload.stepList;
            state.step = action.payload.step;
            state.funnelType = action.payload.funnelType;
            state.isOpen = true;
        },
    },
});

export const selectCurrentStep = (state: RootState) => state.journey.step;

export const {
    openJourney,
    closeJourney,
    setIsOpen,
    setUnitJourneyStep,
    setFunnelType,
    setSelectedUnitId,
    setSelectedUnitGroup,
    setSelectedPromo,
    setStepList,
    resetJourney,
    goBackStep,
    initializeJourney,
} = journeySlice.actions;

export default journeySlice.reducer;
